// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__4S9Q_","footer":"ModalFilter_footer__1CsVQ"};